import { Button } from '@material-tailwind/react';
import React from 'react';
import { Timer } from './timer';

interface ITimelineDetails {
  time: string;
  topic: string;
  shortDetails: string;
}
export const Timeline: React.FC<{
  liveStreamingDetails: {
    actualStartTime: string;
    actualEndTime: string;
    scheduledStartTime: string;
  };
  isLiveEvent: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ liveStreamingDetails, isLiveEvent, setOpenDialog }) => {
  const videoTimelineDetails: ITimelineDetails[] = [
    {
      time: '',
      topic: 'INTRODUCTION',
      shortDetails: '',
    },
    {
      time: '',
      topic: 'House rules',
      shortDetails: '',
    },
    {
      time: '',
      topic: 'About powerlabs',
      shortDetails: '',
    },
  ];
  return (
    <>
      <div className="flex justify-center ">
        <div className=" flex-col justify-between bg-red w-10/12 md:flex md:flex-row">
          <div className="  text-left grid gap-8 " style={{ width: 'calc((100% - 100px) / 2)' }}>
            <div>
              <h1 className="text-5xl font-bold text-secondary mb-4">EVENT TIMELINE</h1>
              <p className="text-gray-500 mb-4">
                Don't miss the opportunity to learn ways to prevent your business from shutting down
                due to high energy costs.
              </p>

              {isLiveEvent ? (
                <>
                  <Button
                    variant="text"
                    className="flex items-center gap-2 text-secondary bg-primary"
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                    onClick={() => setOpenDialog(true)}
                  >
                    Register now{' '}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="h-5 w-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                      />
                    </svg>
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="text"
                    className="flex items-center gap-2 text-secondary bg-primary"
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                    onClick={() => setOpenDialog(true)}
                  >
                    Request video
                  </Button>
                </>
              )}
            </div>

            <div>
              <h3 className="text-bold text-3xl text-secondary mb-4">Webinar starts in:</h3>
              <Timer scheduledTime={liveStreamingDetails.scheduledStartTime} />
            </div>
          </div>
          <div className=" grid mt-10 md:mt-0" style={{ width: 'calc((100% - 100px) / 2)' }}>
            <div>
              {videoTimelineDetails.map((vidDetails, index) => (
                <div className="flex mb-3" key={index}>
                  <div className="grid justify-items-center mr-10 ">
                    <p className="w-8 h-8 grid place-content-center bg-tetiary text-secondary rounded-full mb-2">
                      {/* {vidDetails.time} */}
                    </p>
                    <div
                      className={`w-px bg-primary h-24 ${
                        index === videoTimelineDetails.length - 1 ? 'hidden' : ''
                      }`}
                    ></div>
                  </div>
                  <div className="text-left">
                    <h3 className="text-2xl font-bold text-secondary mb-2">
                      {vidDetails.topic.toUpperCase()}
                    </h3>
                    <p className="text-gray-500">{vidDetails.shortDetails}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
